// Переход на страницу платёжного сервиса — полный уход с сайта. Отдельной функцией, чтобы
// тесты могли её подменить: в jsdom `location.assign` не работает.
export const goToPaymentPage = (url: string): void => {
  window.location.assign(url);
};
